import React, { useState, useEffect } from 'react';

export default function Changelog() {
    const [isOpen, setIsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const handleClick = (e) => {
        e.stopPropagation();
        setIsOpen(true);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setIsOpen(false);
    };

    const changelogButtonStyle = {
        position: 'fixed',
        right: '5px',
        top: '140px',
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        padding: '8px 20px',
        borderRadius: '3px',
        color: 'white',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        fontFamily: 'HelveticaNeue, Arial, sans-serif',
        fontSize: '12px',
        letterSpacing: '0.05em',
        backdropFilter: 'blur(5px)',
        zIndex: 1001,
        pointerEvents: 'auto'
    };

    const modalStyle = {
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(0, 0, 0, 0.95)',
        padding: '30px',
        borderRadius: '5px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: 'white',
        fontFamily: 'HelveticaNeue, Arial, sans-serif',
        fontSize: '14px',
        letterSpacing: '0.05em',
        maxWidth: '600px',
        width: '80%',
        maxHeight: '80vh',
        zIndex: 3000,
        backdropFilter: 'blur(10px)',
        pointerEvents: 'auto'
    };

    const contentStyle = {
        maxHeight: 'calc(80vh - 100px)', // Account for padding and headers
        overflowY: 'auto',
        paddingRight: '15px', // Add padding for scrollbar
        marginRight: '-15px', // Compensate for padding to align with modal
    };

    const overlayStyle = {
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        zIndex: 2999,
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: 'transparent',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '3px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        fontFamily: 'HelveticaNeue, Arial, sans-serif',
        fontSize: '12px',
    };

    const sectionStyle = {
        marginBottom: '25px',
    };

    const headerStyle = {
        margin: '0 0 10px 0',
        fontSize: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };

    const dateStyle = {
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.6)',
        fontWeight: 'normal',
    };

    const listStyle = {
        margin: '0',
        paddingLeft: '20px',
        listStyle: 'disc',
    };

    const listItemStyle = {
        marginBottom: '5px',
    };

    const todoStyle = {
        ...sectionStyle,
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        paddingTop: '20px',
    };

    const changelogContent = [
        {
            version: "1.6.0",
            date: "13-04-2025",
            changes: [
                "Enhanced the camera movement",
                "Added new camera positions",
            ]
        },
        {
            version: "1.5.0",
            date: "12-04-2025",
            changes: [
                "Removed leva controls for the smoke particles",
                "Added camera scroll animation with curve points",
                "Added look at points for the camera",
                "Added buttons to navigate through curve points",
                "Added BTC realtime price for the car",
            ]
        },
        {
            version: "1.4.2",
            date: "10-04-2025",
            changes: [
                "Added websocket client to get current Bitcoin price",
                "Removed transform controls from the car model",
            ]
        },
        {
            version: "1.4.1",
            date: "07-04-2025",
            changes: [
                "Added color scheme to the loading screen",
            ]
        },
        {
            version: "1.4.0",
            date: "06-04-2025",
            changes: [
                "Added sound to the loading screen",
            ]
        },
        {
            version: "1.3.0",
            date: "04-04-2025",
            changes: [
                "Added animated TAG logo to loading screen",
                "Added smooth fade out animation for TAG after loading",
                "Optimized smoke effect to prevent re-rendering",
            ]
        },
        {
            version: "1.2.0",
            date: "01-04-2025",
            changes: [
                "Added smoke effect to the loading screen",
                "Added fade animation for smoke when loading completes",
                "Customizable smoke parameters (color, density, opacity)",
            ]
        },
        {
            version: "1.1.0",
            date: "26-03-2025",
            changes: [
                "Temporarily removed car movement",
                "Temporarily removed scroll camera animation",
                "Added smooth animations for car appearance",
                "Added sound visualization",
                "Added engine mock sound",
                "Added changelog window",
                "Added exhaust smoke particles shader",
                "Added Leva controls for smoke particles",
                "Added sound context for smoke particles",
                "Added FFT analysis for engine sound",
                "Added exhaust shake effect correlated with engine sound through FFT analysis",
            ]
        },
        {
            version: "1.0.0",
            date: "25-03-2025",
            changes: [
                "Initial release",
                "Added preloader page",
                "Added 3D model of RX-7 FD",
                "Added dynamic lighting system",
                "Added camera scrolling",
                "Added wheel rotation", 
                "Added floor infinite movement",
                "Added overlay with controls and metrics",
                "Added procedural generation of the buildings"
            ]
        }
    ];

    const todoItems = [
        "Fix fading out certain elements",
        "Add information to end page",
        "Add more stuff to the scene",
        "Add mobile support",
    ];

    return (
        <>
            <button
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    ...changelogButtonStyle,
                    boxShadow: isHovered ? '0 0 15px rgba(255, 255, 255, 0.2)' : 'none',
                    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                }}
            >
                Changelog
            </button>

            {isOpen && (
                <div style={overlayStyle} onClick={handleClose}>
                    <div style={modalStyle} onClick={e => e.stopPropagation()}>
                        <button style={closeButtonStyle} onClick={handleClose}>
                            Close
                        </button>
                        <div style={contentStyle}>
                            <h2 style={{ margin: '0 0 20px 0', fontSize: '18px' }}>Changelog</h2>
                            {changelogContent.map((release, index) => (
                                <div key={index} style={sectionStyle}>
                                    <h3 style={headerStyle}>
                                        <span>Version {release.version}</span>
                                        <span style={dateStyle}>{release.date}</span>
                                    </h3>
                                    <ul style={listStyle}>
                                        {release.changes.map((change, changeIndex) => (
                                            <li key={changeIndex} style={listItemStyle}>
                                                {change}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            <div style={todoStyle}>
                                <h3 style={{ ...headerStyle, marginBottom: '15px' }}>TODO</h3>
                                <ul style={listStyle}>
                                    {todoItems.map((item, index) => (
                                        <li key={index} style={listItemStyle}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
} 